/**
 * Created by carlos on 23/10/2024.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('revenueProductionSsrCtrl', revenueProductionSsrCtrl);

    function calendarView(vm, datePickerService){
        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: false
            },
            closed: function (args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }

    function revenueProductionSsrCtrl(linkService, tabRevenue, ssrS, classifications,
                                   revenueProductionSsrService, datePickerService/*, plaqueAirCrafts*/, itineraryService,
                                   $uibModal, flights,$stateParams, messageService) {
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabRevenue;
        vm.tabs = tabRevenue;

        vm.pages = flights.page;

        vm.$uibModal = $uibModal;

        vm.searchFrom = {
            'actualDate': ($stateParams.departureDate != "") ? new Date(parseInt($stateParams.departureDate)) : new Date(),
            'classification': ""
        };

        vm.classifications = (classifications.data._embedded?classifications.data._embedded.ssrClassifications:[]);

        for(var c=0; c < vm.classifications.length; c++){
            if($stateParams.classificationSsrId!="") {
                if (linkService.getLinkId(vm.classifications[c]._links.self.href) == $stateParams.classificationSsrId) {
                    vm.searchFrom.classification = vm.classifications[c];
                }
            }
        }

        calendarView(vm, datePickerService);


        vm.itineraryFlights = [];

        var ts = 0;
        var plaque = 0;

        vm.itineraryFlights = getItineraryFlightsProduction(vm.linkService, (flights._embedded?flights._embedded.flights:[]), ssrS);

        vm.searchProductionSsr = function (isValid, searchForm) {
            ts = Date.parse(searchForm.actualDate);

            vm.plaque = "";
            if (searchForm.classification) {
                vm.plaque = linkService.getLinkId(searchForm.classification._links.self.href);
                plaque = vm.plaque;
            }
            linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, departureDate: ts, classificationSsrId: vm.plaque})
        };

        vm.sizeFirstTd = function (position) {
            var size = 0;

            for (var i = 0; i <= vm.itineraryFlights.length; i++) {
                if (i == position) {
                    for (var j = 0; j <= vm.itineraryFlights[i]._embedded.departureflights.length; j++) {
                        if (vm.itineraryFlights[i]._embedded.departureflights[j]) {
                            for (var k = 0; k <= vm.itineraryFlights[i]._embedded.departureflights[j]._embedded.segmentflights.length; k++) {
                                if (vm.itineraryFlights[i]._embedded.departureflights[j]._embedded.segmentflights[k]) {
                                    size = size + vm.itineraryFlights[i]._embedded.departureflights[j]._embedded.segmentflights.length;

                                }
                            }
                        }
                    }
                }
            }

            return size;
        };

        vm.ssrS = ssrS;
        vm.editIndexX = -1;
        vm.auxSegments = [];

        vm.editSegmentItineraryClassSsr = function (indexX) {
            if (vm.editIndexX == indexX || vm.editIndexX == -1) {
                vm.itineraryFlights[indexX].disabledClass = false;
                vm.itineraryFlights[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.itineraryFlights[indexX].segments);
            }
        };

        vm.cancelSegmentItineraryClassSsr = function (indexX) {
            vm.itineraryFlights[indexX].disabledClass = true;
            vm.itineraryFlights[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.itineraryFlights[indexX].segments = angular.copy(vm.auxSegments);
            vm.auxSegments = [];
        };

        vm.saveSegmentItinerarySsr = function (valid, indexX) {

            var save = [];
            if (valid) {
                for (var i = 0; i < vm.itineraryFlights.length; i++) {
                    if (i == indexX) {
                        for (var j = 0; j < vm.itineraryFlights[i].segments.length; j++) {

                            for (var k = 0; k < vm.itineraryFlights[i].segments[j].capacities.length; k++) {
                                var saveObj = {
                                    "allowedQuantity": vm.itineraryFlights[i].segments[j].takeOffCapacity,
                                    "segmentFlightId": parseInt(vm.itineraryFlights[i].segments[j].segmentFlightId),
                                    "segmentFlightSsrId": parseInt(vm.itineraryFlights[i].segments[j].ssrId),
                                    "rbcSegmentSsrs": [
                                        {
                                            "allowedQuantity": parseInt(vm.itineraryFlights[i].segments[j].capacities[k].value),
                                            "segmentSsrId": parseInt(vm.itineraryFlights[i].segments[j].capacities[k].segmentSsrId)
                                        }
                                    ]
                                };

                                save.push(saveObj)
                            }

                        }
                    }
                }
                revenueProductionSsrService.updateSegmentItinerariesSsr(save)
                    .then(function (res) {
                        if (res != "ok") {
                            vm.itineraryFlights[indexX].segments = angular.copy(vm.auxSegments);
                        }
                        vm.itineraryFlights[indexX].disabledClass = true;
                        vm.itineraryFlights[indexX].showEdit = true;
                        vm.editIndexX = -1;
                        vm.auxSegments = [];
                });
            } else {
                messageService.segmentClassValidity();
            }
        };
    }

    function getItineraryFlightsProduction(linkService, flights, ssrS) {
        var segmentItineraries = [];
        var modelAirCraft = "";

        if(flights){
            for (var i = 0; i < flights.length; i++) {

                segmentItineraries.push({
                    "disabledClass": true,
                    "disabledEdit": false,
                    "showEdit": true,
                    "showSave": false,
                    "flightNumber": flights[i].flightNumber,
                    "flightId": linkService.getLinkId(flights[i]._links.self.href),
                    "modelAirCraft": getModelByPosition(flights, i),
                    "segments": [],
                    "ssrs": []
                })

                for (var j = 0; j < flights[i]._embedded.departureflights.length; j++) {
                    if (flights[i]._embedded.departureflights[j]) {
                        modelAirCraft = flights[i]._embedded.departureflights[j]._embedded.modelAircraft.name;
                        for (var k = 0; k < flights[i]._embedded.departureflights[j]._embedded.segmentflights.length; k++) {
                            if (flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]) {
                                segmentItineraries[i].segments.push(
                                    {
                                        "departureFlightId": parseInt(linkService.getLinkId(flights[i]._embedded.departureflights[j]._links.self.href)),
                                        "active": flights[i].active,
                                        "name": flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segment.name,
                                        "departureTime": moment(flights[i]._embedded.departureflights[j].departureDate).format("HH:mm"),
                                        "capacity": flights[i]._embedded.departureflights[j]._embedded.modelAircraft.capacity,
                                        "takeOffCapacity": flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segmentFlightSsr.allowedQuantity,
                                        "id": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._links.self.href),
                                        "oversold": flights[i]._embedded.departureflights[j].openOverSold,
                                        "overLoad": flights[i]._embedded.departureflights[j]._embedded.segmentflights[k].overLoad,
                                        "classId": getClassAndClassIdByPosition( linkService, flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segmentSsrs ).ssrId,
                                        "ssrId": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segmentFlightSsr._links.self.href),
                                        "segmentFlightId": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._links.self.href),
                                        "capacities": getCapacitiesByPosition(ssrS, linkService, flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segmentSsrs)
                                    }
                                );
                            }
                        }
                    }
                }
            }
        }
        return segmentItineraries;
    }

    function getCapacitiesByPosition(ssrS, linkService, segmentSsrs) {
        var capacities = [];
        for (var cl = 0; cl < ssrS.length; cl++) {
            var ssrId = linkService.getLinkId(ssrS[cl]._links.self.href)
            var segmentClass = getSegmentClass(ssrId, segmentSsrs);
                capacities.push(
                    {
                        "classId": ssrId,
                        "value": segmentClass.allowedQuantity,
                        "segmentClassId": linkService.getLinkId(segmentClass._links.self.href),
                        "segmentSsrId": linkService.getLinkId(segmentClass._links.self.href)
                    }
                );
        }
        return capacities;
    }

    function getClassAndClassIdByPosition(linkService, segmentClasses) {

        var classes = {};
        for (var i = 0; i < segmentClasses.length; i++) {
            classes = {
                "classId": segmentClasses[i].ssrId,
                "ssrId": segmentClasses[i].ssrId,
                "segmentClassId": linkService.getLinkId(segmentClasses[i]._links.self.href)
            }
        }

        return classes;
    }

    function getModelByPosition(flights, position) {
        var modelAirCraft = "";
        for (var j = 0; j < flights[position]._embedded.departureflights.length; j++) {
            if (flights[position]._embedded.departureflights[j]) {
                modelAirCraft = flights[position]._embedded.departureflights[j]._embedded.modelAircraft.name;
            }
        }
        return modelAirCraft;
    }

    function getSegmentClass(classId, segmentClassItis) {
        var res = 0;
        if (segmentClassItis != undefined) {
            for (var i = 0; i < segmentClassItis.length; i++) {
                if (segmentClassItis[i].ssrId == classId) {
                    res = segmentClassItis[i];
                    break;
                }
            }
        }
        return res;
    }
})();
